export const dynamic = 'force-dynamic'
import CorporateLogo from '@/components/CorporateLogo/CorporateLogo'
import TeamMembers from '@/components/TeamMembers/TeamMembers'
import TestimonialsSlide from '@/components/Testimonials/TestimonialsSlide'
import React from 'react'
import { Metadata } from 'next';
import urls from '@/utils/urls/urls';
import PartnerLogoContainer from '@/components/PartnerLogo/PartnerLogoContainer';
import AboutIndex from '@/components/About/AboutIndex';
import CorporateLogoContainer from '@/components/CorporateLogo/CorporateLogoContainer';
import WhyChooseUs from '@/components/WhyChooseUs/WhyChooseUs';
import Testimonial from '@/components/Testimonials/Testimonial';
import cl from '@/utils/console/cl';
import StatsCounter from '@/components/Stats/StatsCounter';
import AnimationWrapper from '@/components/AnimationWrapper/AnimationWrapper';

export const metadata: Metadata = {
  title: 'About Us | TEX EXCELLENCE LIMITED',
  description: 'About Us | TEX EXCELLENCE LIMITED',
}


export default async function AboutPage() {
  // const about = await fetch('https://jsonplaceholder.typicode.com/posts')
  // const aboutRes = await fetch("http://localhost:8080/api/about")
  // const aboutRes = await fetch(urls?.about)
  // const aboutData = await aboutRes.json()
  // cl("aboutData", aboutData)
  // const about = aboutData?.data[0]
  // cl("about", about);

  return (
    <div className="bg-white">
      {/* preloader */}
      {/* <div className="preloader">
        <div className="loader-ripple">
          <div />
          <div />
        </div>
      </div> */}
      {/* preloader end */}
      {/* header area */}
      {/* <header className="header"> */}
      {/* header top */}
      {/* <div className="header-top">
          <div className="shape">
            <div className="shape-1" />
            <div className="shape-2" />
          </div>
          <div className="container pe-0">
            <div className="header-top-wrap">
              <div className="header-top-left">
                <div className="header-top-list">
                  <ul>
                    <li>
                      <a href="https://live.themewild.com/cdn-cgi/l/email-protection#d4bdbab2bb94b1acb5b9a4b8b1fab7bbb9">
                        <i className="far fa-envelopes" />
                        <span
                          className="__cf_email__"
                          data-cfemail="11787f777e517469707c617d743f727e7c"
                        >
                          email
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="tel:">
                        <i className="far fa-phone-volume" /> 
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="far fa-alarm-clock" /> Sun - Fri (08AM - 10PM)
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header-top-right">
                <div className="header-top-list">
                  <a href="login">
                    <i className="far fa-sign-in" /> Login
                  </a>
                </div>
                <div className="header-top-lang">
                  <div className="dropdown">
                    <a
                      href="#"
                      className="top-lang dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <i className="fal fa-globe" /> Eng
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <a className="dropdown-item" href="#">
                          English
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          German
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Russian
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Spanish
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="header-top-social">
                  <span>Follow Us: </span>
                  <a href="#">
                    <i className="fab fa-facebook" />
                  </a>
                  <a href="#">
                    <i className="fab fa-x-twitter" />
                  </a>
                  <a href="#">
                    <i className="fab fa-instagram" />
                  </a>
                  <a href="#">
                    <i className="fab fa-linkedin" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      {/* header top end */}
      {/* navbar */}

      {/* navbar end*/}
      {/* </header> */}
      {/* header area end */}
      {/* popup search */}
      {/* <div className="search-popup">
        <button className="close-search">
          <span className="far fa-times" />
        </button>
        <form action="#">
          <div className="form-group">
            <input
              type="search"
              name="search-field"
              className="form-control"
              placeholder="Search Here..."
              required
            />
            <button type="submit">
              <i className="far fa-search" />
            </button>
          </div>
        </form>
      </div> */}
      {/* popup search end */}
      {/* sidebar-popup */}
      {/* <div
        className="sidebar-popup offcanvas offcanvas-end"
        tabIndex={-1}
        id="sidebarPopup"
      >
        <div className="offcanvas-header">
          <a href="index-2" className="sidebar-popup-logo">
            <img src="assets/img/logo/logo.png" alt="" />
          </a>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="far fa-xmark" />
          </button>
        </div>
        <div className="sidebar-popup-wrap offcanvas-body">
          <div className="sidebar-popup-content">
            <div className="sidebar-popup-about">
              <h4>About Us</h4>
              <p>
                There are many variations of passages available sure there majority
                have suffered alteration in some form by inject humour or randomised
                words which don't look even slightly believable.
              </p>
            </div>
            <div className="sidebar-popup-contact">
              <h4>Contact Info</h4>
              <ul>
                <li>
                  <div className="icon">
                    <i className="far fa-envelope" />
                  </div>
                  <div className="content">
                    <h6>Email</h6>
                    <a href="https://live.themewild.com/cdn-cgi/l/email-protection#90f9fef6ffd0f5e8f1fde0fcf5bef3fffd">
                      <span
                        className="__cf_email__"
                        data-cfemail="543d3a323b14312c35392438317a373b39"
                      >
                        email
                      </span>
                    </a>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <i className="far fa-phone" />
                  </div>
                  <div className="content">
                    <h6>Phone</h6>
                    <a href="tel:"></a>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <i className="far fa-location-dot" />
                  </div>
                  <div className="content">
                    <h6>Address</h6>
                    <a href="#"></a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="sidebar-popup-social">
              <h4>Follow Us</h4>
              <a href="#">
                <i className="fab fa-facebook" />
              </a>
              <a href="#">
                <i className="fab fa-x-twitter" />
              </a>
              <a href="#">
                <i className="fab fa-instagram" />
              </a>
              <a href="#">
                <i className="fab fa-linkedin" />
              </a>
            </div>
          </div>
        </div>
      </div> */}
      {/* sidebar-popup end */}
      <main className="main">
        {/* breadcrumb */}
        <div
          className="site-breadcrumb"
          style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
        >
          <div className="container">
            <h2 className="breadcrumb-title">About Us</h2>
            <ul className="breadcrumb-menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li className="active">About Us</li>
            </ul>
          </div>
        </div>
        {/* breadcrumb end */}
        {/* about area */}
        <AboutIndex />
        {/* about area end */}
        {/* counter area */}
        <AnimationWrapper animation="fade-up">
          <StatsCounter />
        </AnimationWrapper>
        {/* <div className="counter-area pt-40 pb-40">
          <div className="container">
            <div className="row g-4 justify-content-center">
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="counter-box wow fadeInUp" data-wow-delay=".25s">
                  <div className="icon">
                    <img src="assets/img/icon/solar.svg" alt="" />
                  </div>
                  <div className="content">
                    <div className="info">
                      <span
                        className="counter"
                        data-count="+"
                        data-to={150}
                        data-speed={3000}
                      >
                        150
                      </span>
                      <span className="unit">k</span>
                    </div>
                    <h6 className="title">Projects Done</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="counter-box wow fadeInDown" data-wow-delay=".25s">
                  <div className="icon">
                    <img src="assets/img/icon/rating.svg" alt="" />
                  </div>
                  <div className="content">
                    <div className="info">
                      <span
                        className="counter"
                        data-count="+"
                        data-to={25}
                        data-speed={3000}
                      >
                        25
                      </span>
                      <span className="unit">K</span>
                    </div>
                    <h6 className="title">Happy Clients</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="counter-box wow fadeInUp" data-wow-delay=".25s">
                  <div className="icon">
                    <img src="assets/img/icon/staff.svg" alt="" />
                  </div>
                  <div className="content">
                    <div className="info">
                      <span
                        className="counter"
                        data-count="+"
                        data-to={120}
                        data-speed={3000}
                      >
                        120
                      </span>
                      <span className="unit">+</span>
                    </div>
                    <h6 className="title">Experts Staff</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="counter-box wow fadeInDown" data-wow-delay=".25s">
                  <div className="icon">
                    <img src="assets/img/icon/award.svg" alt="" />
                  </div>
                  <div className="content">
                    <div className="info">
                      <span
                        className="counter"
                        data-count="+"
                        data-to={50}
                        data-speed={3000}
                      >
                        50
                      </span>
                      <span className="unit">+</span>
                    </div>
                    <h6 className="title">Win Awards</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* counter area end */}
        {/* team-area */}
        {/* <TeamMembers /> */}
        <AnimationWrapper animation="fade-up"><PartnerLogoContainer /></AnimationWrapper>
        {/* team-area end */}
        {/* testimonial-area */}
        <Testimonial />
        {/* <div className="testimonial-area tm-bg pt-80 pb-60">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div className="site-heading wow fadeInDown" data-wow-delay=".25s">
                  <span className="site-title-tagline">
                    <i className="fas fa-solar-panel" /> Testimonials
                  </span>
                  <h2 className="site-title text-white">
                    What Our Client <span>Say's</span> about us
                  </h2>
                  <p className="text-white">
                    It is a long established fact that a reader will be distracted
                    by the readable content of a page when looking at its layout.
                    All the generators on the Internet tend to repeat predefined
                    chunks.
                  </p>
                  <a href="contact" className="theme-btn mt-30">
                    Know More <i className="fas fa-arrow-right" />
                  </a>
                </div>
              </div>
              <div className="col-lg-8">
                <TestimonialsSlide />
              </div>
            </div>
          </div>
        </div> */}
        {/* testimonial-area end */}
        {/* choose area */}
        <WhyChooseUs />
        {/* <div className="choose-area py-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="choose-content wow fadeInUp" data-wow-delay=".25s">
                  <div className="site-heading mb-0">
                    <span className="site-title-tagline">
                      <i className="fas fa-solar-panel" /> Why Choose Us
                    </span>
                    <h2 className="site-title">
                      We deliver <span>expertise you can trust</span> our service
                    </h2>
                    <p>
                      It is a long established fact that a reader will be distracted
                      by the readable content of a page when looking at its layout.
                    </p>
                  </div>
                  <div className="choose-content-wrap">
                    <div className="choose-item">
                      <div className="choose-item-icon">
                        <img src="../assets/img/icon/money-2.svg" alt="" />
                      </div>
                      <div className="choose-item-info">
                        <h4>Affordable Cost</h4>
                        <p>
                          At Tex Excellence Limited, our mission is to assist brands, designers, and manufacturers in creating cutting-edge fabric technologies that significantly enhance the final products.
                        </p>
                      </div>
                    </div>
                    <div className="choose-item">
                      <div className="choose-item-icon">
                        <img src="../assets/img/icon/staff.svg" alt="" />
                      </div>
                      <div className="choose-item-info">
                        <h4>Our Experience Team</h4>
                        <p>
                          There are many variations of passages available the
                          majority have suffered alteration in some by injected
                          humour.
                        </p>
                      </div>
                    </div>
                    <div className="choose-item">
                      <div className="choose-item-icon">
                        <img src="../assets/img/icon/certified.svg" alt="" />
                      </div>
                      <div className="choose-item-info">
                        <h4>Certified Company</h4>
                        <p>
                          There are many variations of passages available the
                          majority have suffered alteration in some by injected
                          humour.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="choose-img wow fadeInRight" data-wow-delay=".25s">
                  <img className="img-1" src="../assets/img/choose/11.jpg" alt="" />
                  <img className="img-2" src="../assets/img/choose/22.jpg" alt="" />
                  <img className="shape" src="../assets/img/shape/pailung_logo.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* choose area end */}
        {/* partner area */}
        <div className="partner-area bg pt-50 pb-50"
          style={{
            background: "#FFFFFF"
          }}
        >
          <div className="container"

          >
            <CorporateLogoContainer />
            {/* <div className="partner-slider owl-carousel owl-theme">
              <img src="assets/img/partner/01.png" alt="thumb" />
              <img src="assets/img/partner/02.png" alt="thumb" />
              <img src="assets/img/partner/03.png" alt="thumb" />
              <img src="assets/img/partner/04.png" alt="thumb" />
              <img src="assets/img/partner/01.png" alt="thumb" />
              <img src="assets/img/partner/02.png" alt="thumb" />
              <img src="assets/img/partner/03.png" alt="thumb" />
            </div> */}
          </div>
        </div>
        {/* partner area end */}
      </main>
      {/* footer area */}

      {/* footer area end */}
      {/* scroll-top */}
      <a href="#" id="scroll-top">
        <i className="far fa-arrow-up" />
      </a>
      {/* scroll-top end */}
      {/* js */}
    </div>

  )
}

